export enum ArtistTierStrmEnum {
  NotEligible = 0,
  StrmMusic = 1,
  StrmStars = 2,
  StrmLegends = 3,
  StrmSpotlight = 4,
}
